<template>

  <v-container class="pa-0 ma-0 step delivery-step-claim-vehicle" v-if="route && hq && vehicle">

    <v-row class="pa-0 ma-0">
      <v-col sm="12" class="d-flex flex-column align-left justify-center">
        <!-- HQ info -->
        <v-row>
          <v-col sm="12" class="ma-0 pa-0 content-title">{{ hq.name }}</v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="ma-0 pa-0 pt-2 address-text d-flex align-center">
            <div>
              <div>{{ formatAddress(hq).street_1 }}</div>
              <div v-if="formatAddress(hq).street_2">{{ formatAddress(hq).street_2 }}</div>
              <div v-if="formatAddress(hq).area">{{ formatAddress(hq).area }}</div>
            </div>
            <v-btn plain color="primary" class="ml-6" @click="copyAddress">
              <v-icon class="icon-copy">mdi-content-copy</v-icon>
            </v-btn>
          </v-col>
        </v-row>

        <!-- directions link -->
        <v-row v-if="showDrivingDirections">
          <v-col sm="12" class="ma-0 pa-0 mt-3">
            <v-btn text color="primary">
              <v-icon class="icon-open-in-new">mdi-open-in-new</v-icon>
              <span>Driving directions</span>
            </v-btn>
          </v-col>
        </v-row>

        <!-- vehicle info -->
        <v-row class="mt-10">
          <v-col class="ma-0 pa-0 content-title">Vehicle</v-col>
        </v-row>
        <v-row>
          <v-col sm="12" class="ma-0 pa-0 mt-3 vehicle-text content-accent">
            {{ vehicle.year }} {{ vehicle.make }} {{ vehicle.vehicle_model }}
          </v-col>
        </v-row>
        <v-row>
          <v-col sm="12" class="ma-0 pa-0 vehicle-text ">
            color: <span class="content-accent">{{ vehicle.color }}</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="ma-0 pa-0 vehicle-text">
            plate: <span class="content-accent">{{ vehicle.license_plate }}</span>
          </v-col>
        </v-row>

        <!-- disclaimer -->
        <!-- <v-row>
          <v-col class="ma-0 px-0 pt-2 pb-1 disclaimer-text">
            {{ odometerEntryMessageText }}
          </v-col>
        </v-row> -->

        <!-- Odometer reading -->
        <v-row class="mt-8">
          <v-col cols="12" xs="12" sm="6" md="6" lg="5" class="ma-0 px-0 pt-2 pb-0">
            <span class="input-label-text">Odometer reading (optional)</span>
            <v-text-field
                outlined
                clearable
                :disabled="hasCompleted !== null"
                maxlength="6"
                class="mt-2"
                v-model.trim="odometerReading" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Complete step -->
    <v-row class="complete-step px-0">
      <v-col sm="12" class="d-flex flex-column align-left justify-center">
        <v-btn color="primary" v-if="isClaimVehicleProcessing">
          <v-progress-circular indeterminate :size="20" color="white" />
        </v-btn>
        <v-btn
            large
            color="primary"
            :disabled="true"
            v-else-if="hasCompleted">
          Claimed at {{ formatDateTime(hasCompleted) }}
        </v-btn>
        <double-click-confirm-button
            v-else
            buttonText="Claim Vehicle"
            confirmTitle="Vehicle has been claimed."
            @confirmed="completeStep" />
      </v-col>
    </v-row>

  </v-container>

</template>

<script>
import DoubleClickConfirmButton from '@/components/app/DoubleClickConfirmButton'

export default {
  name: 'DeliveryStepClaimVehicle',

  components: {
    DoubleClickConfirmButton
  },

  props: {
    hq: {
      type: Object,
      required: true
    },
    route: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      isClaimVehicleProcessing: false,
      showDrivingDirections: false,
      vehicle: {},
      odometerReading: null
    }
  },

  computed: {
    hasCompleted () {
      return this.route.vehicle_claimed_at
    }
  },

  async beforeMount () {
    this.odometerReading = this.route.odometer_reading_start
    if (this.route.vehicle_id) {
      this.vehicle = await this.$store.dispatch('sh/fetchData', { resource: 'vehicle', id: this.route.vehicle_id })
    }
  },

  // computed: {
  //   odometerEntryMessageText () {
  //     return 'Please ensure vehicle is operational. If you are unable to use this vehicle please contact the office immediately. Otherwise, enter the odometer reading below.'
  //   }
  // },

  methods: {
    // copy address to clipboard
    copyAddress () {
      this.$root.copyToClipboard(this.$root.utils.getAddressTextFromData(this.hq))
    },

    // Display a date/time
    formatDateTime (date) {
      return (date) ? this.$root.utils.dateFormat(date, 'MMM D h:mma') : ''
    },

    formatAddress (data = {}) {
      return this.$root.utils.getAddressTextFromData(data, { multi_lines: true })
    },

    // Save odometer reading, and complete step
    async completeStep () {
      this.isClaimVehicleProcessing = true

      try {
        const data = {
          routeId: this.route.id,
          odometerReading: this.odometerReading
        }
        await this.$store.dispatch('sh/claimVehicle', data)
        this.$emit('completed')
      } catch (err) {
        console.log('Error claiming vehicle =>', err)
      }

      this.isClaimVehicleProcessing = false
    }
  }
}
</script>

<style scoped>
  .v-application .text-overline {
    letter-spacing: .01em;
    line-height: 1.4em;
  }
</style>
